<template>
    <s-dialog :dialog="dialogStatus">
        <template v-if="statusNow === 'success'">
            <section class="successContent" slot="content" >
                <img :src="`${env$}static/svg/connect/sucess.svg`" alt=""/>
            </section>
        </template>
        
        <template  v-else-if="statusNow === 'failed'">
           <section class="failedContent" slot="content">
                <img :src="`${env$}static/svg/connect/failed.svg`" alt="">
                <el-input type="textarea" readonly :resize="'none'" :value="dialogStatus.textAreaText"></el-input>
            </section>
        </template>

        <template v-else>
            <template v-if="!handleCurrentVersion()">
                <section class="emptyContent" slot="content">
                    <p class="inputIpTitle">{{ dialogStatus.contentLabel }}</p>
                    <!-- <p :class="[shit$(`opacity:${submitState === 2 ? 1 : 0};`), shit$(`c:#fd5c53; font:12px; letter-s:0.6px; h:18px; lh:18px; mb:6px!; text-a:c;`)]">{{this.$t( "code-lab/component/connection/status.vue_0" ) }} {{this.$t( "code-lab/component/connection/status.vue_1" ) }}</p> -->
                    <div :class="shit$(`dis:f; justify-c:sb; relative;`)">
                      <template v-for="(o, i) in 6">
                        <input @focus="() => input1focusIndex = i" @blur="() => input1focusIndex = -1" :ref="'input1-' + i"  v-model="input1[i]" :key="o" :class="[submitState === 2 && shit$(`c:#fd5c53!;`), input1focusIndex === i && shit$(`bc:#a8a8ac!;`),shit$(`font:21px; font-w:900; letter-s:1.5px; text-a:c; c:#0ed3ff;`), o === 3 && shit$(`mr:20px;`), shit$(`w:40px; h:50px; radius: 8px; b:2px; bc:#696969!; bgc:#333;`)]"/>
                      </template>
                      <div :class="shit$(`w:100%; h:100%; absolute; top; left;`)" tabindex='-1'  @focus="input1FocusEvent" ></div>
                    </div>
                    <!-- <el-input v-model.trim="ipAdress" :placeholder="dialogStatus.placeholder || 'IP'"></el-input> -->
                    <p :class="[ 'inputIpTitle', shit$(`mb:15px!; mt:25px!important;`) ]">{{ dialogStatus.contentLabelBottom }}</p>
                    <div :class="shit$(`dis:f; justify-c:sb; relative;`)">
                      <template v-for="(o, i) in 6">
                        <input @focus="() => input2focusIndex = i" @blur="() => input2focusIndex = -1" :ref="'input2-' + i"  v-model="input2[i]" :key="o" :class="[submitState === 2 && shit$(`c:#fd5c53!;`), input2focusIndex === i && shit$(`bc:#a8a8ac!;`),shit$(`font:21px; font-w:900; letter-s:1.5px; text-a:c; c:#0ed3ff;`), o === 3 && shit$(`mr:20px;`), shit$(`w:40px; h:50px; radius: 8px; b:2px; bc:#696969!; bgc:#333;`)]"/>
                      </template>
                      <div :class="shit$(`w:100%; h:100%; absolute; top; left;`)" tabindex='-1'  @focus="input2FocusEvent" ></div>
                    </div>
                    <!-- <el-input v-model.trim="lastCode" :placeholder="dialogStatus.placeholder"></el-input> -->
                    <p class="findIp">
                        <span @click="handleHelp" :class="{ filledHelp: false  }">{{ dialogStatus.helpTitle }}</span>
                        <!-- <span @click="handleHelp" :class="{ filledHelp: statusNow === 'filled'  }">{{ dialogStatus.helpTitle }}</span> -->
                    </p>
                </section>
            </template>
        </template>
        
        <footer slot="footer">
            <el-button class="cancelBtn" @click="handleEvent(-1)">{{ dialogStatus.cancel['text'] }}</el-button>
            <el-button  :class="[
                { filledBtn: statusNow === 'filled' && submitState !== 2, failedBtn: statusNow ==='failed' },
                statusNow === 'empty' && shit$(`cursor:n; hover:c:rgba(105,105,105,1);`),
                submitState === 2 && shit$(`cursor:n;`)
            ]" class="confirmBtn" type="primary" @click="handleEvent(1)">{{ dialogStatus.confirm['text'] }}</el-button>
            <connect-description
            ref="connect-description"
            v-if="isShowChild"
        />
        </footer>
    </s-dialog>
</template>

<script>
import sDialog from "@/code-lab/view/organization/s-dialog.vue";
import connectDescription from "@/code-lab/component/connection/description.vue";
import { mapState } from "vuex";
export default {
  name: "connect-status",
  components: {
    sDialog,
    connectDescription
  },
  props: {
    dialogStatus: Object,
    stateMachineStatus: Object,
    isConnectStatus: Boolean,
    isShowChild: Boolean,
    typeOfConnect: String,
  },
  data: () => ({
    input1: [],
    input1Max: 6,
    input1focusIndex: -1,
    input2: [],
    input2Max: 6,
    input2focusIndex: -1,
    lastCode: "",
    ipAdress: "",
    statusNow: "empty",
    submitState: -1 
  }),
  computed: {
    ...mapState({
      currentVersion: "currentVersion",
      env$: "env$",
    }),
    ...mapState("quickConnection", [ "socketCode" ])
  },
  created () {
    this.updateData(this.dialogStatus, { isShow: this.isConnectStatus });
    this.lastCode = localStorage.getItem("robotLastSixCode") || ''
    if (this.lastCode) this.input2 = this.lastCode.split("")
    this.$nextTick(() => {
      this.getInputFocus(this.input1, "input1-", this.input1Max)
    })
    document.addEventListener('keydown', this.keyDownEvent)
  },
  destroyed () {
    document.removeEventListener('keydown', this.keyDownEvent)
  },
  methods: {
    keyDownEvent (event) {
      if (event.keyCode === 8) {
        if (this.input1focusIndex !== -1) {
          this.input1.pop()
          this.submitState = 0
        } else if (this.input2focusIndex !== -1) {
          this.input2.pop()
          this.submitState = 0
        }
      } else if(event.keyCode === 13){
        this.handleEvent(1)
      }
    },
    getInputFocus (value, str = "input1-", max = this.input1Max ) {
      this.$nextTick(() => {
        const len = value.length >= max ? (max - 1) : value.length
        const ref = this.$refs[str + len]
        const elm = ref && ref[0]
        elm && elm.focus()
      })
    },
    input1FocusEvent () {
      this.getInputFocus(this.input1, "input1-", this.input1Max)
    },
    input2FocusEvent () {
      this.getInputFocus(this.input2, "input2-", this.input2Max)
    },
    handleCurrentVersion () {
      const mapping = {
        public: true,
        student: false,
        teacher: false,
        family: false
      };
      return mapping[this.currentVersion];
    },
    updateData (key, value) {
      Object.assign(key, value);
    },
    handleStatusNow (value) {
      
      this.updateData(this, { statusNow: value });
    },
    handleHelp () {
      if (!this.isShowChild) return false;
      this.$refs["connect-description"].handleEvent(true);
    },
    handleEvent (key) {
     if ( key < 0 ) {
        console.log('destroyed project')
        this.b$.close(this.typeOfConnect)
        this.close()
     } else if ( this.statusNow === "filled" ) {
        if (this.submitState === 2) return
        this.$emit( "connect", this.handleCurrentVersion() ? this.ipAdress : [this.ipAdress, this.lastCode] )
        this.submitState = 1
     }
    },
    close (value = false) {
      this.updateData(this.dialogStatus, { isShow: value });
      this.$emit("handleEventBtn", value);
    },
    verificationLastCode () {
      if (this.lastCode.length === this.input2Max && this.ipAdress.length === this.input1Max) {
        this.updateData(this, { statusNow: "filled" });
      } else {
        this.updateData(this, { statusNow: "empty" });
      }
    }
  },
  watch: {
    socketCode (code) {
      if (code === 4002) {
        if (this.submitState === 1) {
          this.submitState = 2
        }
      }
    },
    input1: {
      handler (value) {
        this.getInputFocus(value, "input1-", this.input1Max)
        if (value.join("").length > this.input1Max) {
          this.input1 = value.join("").split("").splice(0, 6)
        }
        this.ipAdress = this.input1.join("")
      }
    },
    input2: {
      handler (value) {
        this.getInputFocus(value, "input2-", this.input2Max)
        if (value.join("").length > this.input2Max) {
          this.input2 = value.join("").split("").splice(0, 6)
        }
        this.lastCode = this.input2.join("")
      }
    },
    ipAdress (value) {
      const flag = value.length === this.input1Max;
      const status = { true: "filled", false: "empty" };
      const statusNow = status[flag];
      if (!this.handleCurrentVersion()) {
        this.verificationLastCode();
      } else {
        this.updateData(this, { statusNow });
      }
    },
    lastCode () {
      this.verificationLastCode();
    },
    statusNow (value) {
      const todo = this.stateMachineStatus[value].to;
      this.updateData(this.dialogStatus, todo);
    }
  }
};
</script>

<style lang='scss' scoped>
.connect-status {
  p {
    margin: 0px;
  }
  .inputIpTitle {
    margin: 0px;
    line-height: 30px;
    margin-bottom: 15px;
    font-size: 20px;
    color: #fff;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 500;
    word-break: break-word;
  }
  .findIp {
    span:hover {
      cursor: pointer;
    }
    width: 340px;
    height: 17px;
    font-size: 12px;
    font-weight: 600;
    color: $--codelab-primary-gray-2;
    text-align: right;
    height: 17px;
    line-height: 17px;
    margin: auto;
    margin-top: 9px;
  }
  .emptyContent {
    margin-bottom: 30px;
  }
  .successContent {
    margin-bottom: 0px;
    display: flex;
    justify-content: center;
  }
}
</style>

<style lang='scss'>
.connect-status {
  .el-dialog__header {
    background-color: $--codelab-primary-black-1;
    
    
    border-radius: 24px 24px 0px 0px;
    letter-spacing: 1px;
    height: 60px;
    padding: 15px 0px 18px 0px;
    .el-dialog__title {
      color: #ffffff;
    }
  }
  .el-dialog--center .el-dialog__body {
    padding: 25px 30px 30px 30px;
    background-color: $--codelab-primary-black-2;
    
    
    border-radius: 0px 0px 24px 24px;
  }
  &.connectStatusDialog {
    border-radius: 24px;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.5);
  }
  .el-input .el-input__inner {
    width: 340px;
    height: 50px;
    border-radius: 8px;
    border: solid 1px #272727;
    background-color: $--codelab-primary-black-2;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0.7px;
    color: $--codelab-primary-blue-1;
    &::focus {
      border-color: #9b9b9f;
    }
  }
  .el-input .el-input__inner:focus {
    border-color: #9b9b9f;
    color: $--codelab-primary-blue-1;
  }
  .el-input--small {
    text-align: center;
  }
  .el-textarea__inner {
    width: 340px;
    height: 90px;
    opacity: 0.55;
    border-radius: 8px;
    background-color: $--codelab-primary-black-1;
    margin: auto;
    margin-top: 15px;
    border: none;
    padding: 10px 20px;
    box-sizing: border-box;
    line-height: 1.64;
    letter-spacing: 1px;
    font-size: 14px;
    color: #ffffff;
  }

  footer {
    width: 340px;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }

  .cancelBtn {
    width: 160px;
    height: 48px;
    border-radius: 32.5px;
    background-color: $--codelab-primary-gray-1;
    color: #fff;
    line-height: 1.44;
    letter-spacing: 0.48px;
    font-size: 16px;
    border: none;
    &:active {
      opacity: 0.5;
    }
    span {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .confirmBtn {
    width: 160px;
    height: 48px;
    border-radius: 32.5px;
    color: #fff;
    line-height: 1.44;
    letter-spacing: 0.48px;
    font-size: 16px;
    border: none;
    background-color: $--codelab-primary-black-3;
    color: $--codelab-primary-gray-3;
    &:active {
      opacity: 0.5;
    }
    span {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .filledBtn {
    background-color: $--codelab-primary-blue-2;
    color: #ffffff;
  }
  .failedBtn {
    background-color: $--codelab-primary-blue-2;
    color: #ffffff;
  }
  .filledHelp {
    color: $--codelab-primary-blue-2;
  }

  .failedContent {
    margin-bottom: 25px;
    display: flex;
    flex-direction: column;
    .el-textarea__inner {
      background-color: $--codelab-primary-black-2;
      font-weight: 500;
    }
  }

  &.el-dialog,
  .el-pager li {
    background-color: $--codelab-primary-black-2;
  }
}
</style>
